export default "__VITE_ASSET__3a54b5cc__"